import { useTranslations } from '@altermaind/core/i18n';
import { Asset, Box, Card, Svg, Typography } from '@altermaind/web/ui';
import { useResponsiveStyle } from '@/_shared/hooks';

export const Programs = () => {
  const t = useTranslations('aiPlayground.learning.landingPlayground.programs');
  const { genericResponsiveValue } = useResponsiveStyle();

  return (
    <Box mt='l'>
      <Box
        alignItems='center'
        display='flex'
        flexDirection={genericResponsiveValue({
          breakPoints: { desktop: 'row' },
          defaultValue: 'column',
        })}
        mt='s'
      >
        <Box alignItems='center' flex='1'>
          <Typography mb='xs' variant='h2'>
            {t('title')}
          </Typography>
          <Typography mb='s' variant='p2/light'>
            {t('description')}
          </Typography>
          <Card display='flex' flexDirection='row' mt='s'>
            <Box mr='xxs'>
              <Svg name='rocket' size='s' />
            </Box>
            <Box>
              <Typography variant='h4'>{t('blocks.block1.title')}</Typography>
              <Typography mt='xxs' variant='p2/light'>
                {t('blocks.block1.description')}
              </Typography>
            </Box>
          </Card>
          <Card display='flex' flexDirection='row' mt='s'>
            <Box mr='xxs'>
              <Svg name='users' size='s' />
            </Box>
            <Box>
              <Typography variant='h4'>{t('blocks.block2.title')}</Typography>
              <Typography mt='xxs' variant='p2/light'>
                {t('blocks.block2.description')}
              </Typography>
            </Box>
          </Card>
          <Card display='flex' flexDirection='row' mt='s'>
            <Box mr='xxs'>
              <Svg name='emptyPlay' size='s' />
            </Box>
            <Box>
              <Typography variant='h4'>{t('blocks.block3.title')}</Typography>
              <Typography mt='xxs' variant='p2/light'>
                {t('blocks.block3.description')}
              </Typography>
            </Box>
          </Card>
        </Box>
        <Box
          ml={genericResponsiveValue({
            breakPoints: { desktop: 'l' },
            defaultValue: 'none',
          })}
          mt={genericResponsiveValue({
            breakPoints: { desktop: 'none' },
            defaultValue: 'l',
          })}
          alignItems='center'
          textAlign='center'
          flex='1'
        >
          <Asset maxWidth='600px' width='100%' name='programs' domain='images' />
        </Box>
      </Box>
    </Box>
  );
};
